<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.css">
<!-- Modal -->
<div class="modal fade" id="documentPreviewModal" tabindex="-1">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content document-modal">
            <div class="modal-header">
                <h5 class="modal-title">
                    <i class="bi bi-folder2-open docIcon"></i>
                    Documents
                </h5>
                <button class="button-close" mat-icon-button (click)="close()" aria-label="close" >
                    <mat-icon aria-label="Close dialog">close</mat-icon>
                </button>
            </div>
            <div *ngIf="isLoading" class="no-data-message">
                Loading documents...
            </div>
            @if(!isLoading && documents.length == 0){
            <div class="no-data-message">
                No documents found.
            </div>
            } @else if(!isLoading && documents.length > 0) {
            <div class="modal-body">
                <div class="table-responsive">
                    <table class="table document-table table-hover align-middle">
                        <thead>
                            <tr>
                                <th width="270">Document</th>
                                <th width="300">File Name</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let doc of documents; let i = index">
                                <td class="subcategory">
                                    {{formatSubCategory(doc.subcategory,doc.fileName,'document')}}
                                </td>
                                <td>
                                    <a class="file-link" (click)="onViewDocument(doc, doc.fileName)">
                                        <i class="bi bi-file-earmark-arrow-down"></i>

                                        {{formatSubCategory(doc.subcategory,doc.fileName,'file name')}}
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            }
            <div class="modal-actions">
                <button
                    *ngIf="canShowDownloadAll"
                    class="download-all-btn"
                    mat-stroked-button
                    type="button"
                    [disabled]="isDownloadingAll || isLoading"
                    (click)="downloadAllDocuments()">
                    {{ isDownloadingAll ? 'Downloading...' : 'Download All Documents' }}
                </button>
                <button mat-raised-button type="button" (click)="close()">Close</button>
            </div>
            <div class="download-all-error" *ngIf="downloadAllErrorMessage">
                {{ downloadAllErrorMessage }}
            </div>
        </div>
    </div>
</div>